import { render, staticRenderFns } from "./ttshop_barter.vue?vue&type=template&id=a8c8d280&scoped=true&"
import script from "./ttshop_barter.vue?vue&type=script&lang=js&"
export * from "./ttshop_barter.vue?vue&type=script&lang=js&"
import style0 from "./ttshop_barter.vue?vue&type=style&index=0&id=a8c8d280&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c8d280",
  null
  
)

export default component.exports